import * as React from 'react'

import { MySpendingsModuleVisibilityDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import { myCardsRoutes } from 'modules/expenses/routes/my_cards'
import { myExpensesRoutes } from 'modules/expenses/routes/my_expenses'
import { myPurchasesRoutes } from 'modules/procurement/routes/my_purchases'

const ReroutingIndex = React.lazy(() => import('modules/finance/pages/ReroutingIndex'))

export const mySpendingModule = buildNavigation((navigation) => {
  return [
    buildModuleRoute({
      handle: {
        module: 'my_spending',
        moduleName: () => i18n.t('sidebar.my_purchases'),
        meta: ({ watchQuery }) => {
          return watchQuery({
            query: MySpendingsModuleVisibilityDocument,
          }).map(({ data }) => {
            const {
              sidebarSeeMyExpensesMyExpensesSubLevelItem,
              sidebarSeeMyExpensesMyCardsSubLevelItem,
            } = data.expenses._policies

            const { sidebarSeeMyExpensesPurchaseRequestSubLevelItem } = data.procurement._policies

            return {
              title: i18n.t('sidebar.my_purchases'),
              subNavigation: [
                {
                  id: 'my-expenses',
                  title: i18n.t('sidebar.my_expenses'),
                  href: navigation.myExpenses.list.expenses.fullPath(),
                  isVisible: sidebarSeeMyExpensesMyExpensesSubLevelItem.can,
                },
                {
                  id: 'my-purchases',
                  title: i18n.t('procurement.purchase_requests.my_purchase_requests.title'),
                  href: navigation.myPurchases.fullPath(),
                  isVisible: sidebarSeeMyExpensesPurchaseRequestSubLevelItem.can,
                },
                {
                  id: 'my-cards',
                  title: i18n.t('sidebar.my_cards'),
                  href: navigation.myCards.fullPath(),
                  isVisible: sidebarSeeMyExpensesMyCardsSubLevelItem.can,
                },
              ],
            }
          })
        },
      },
      children: [
        {
          path: navigation.mySpending.path,
          element: <ReroutingIndex />,
        },
        ...myExpensesRoutes(navigation),
        ...myPurchasesRoutes(navigation),
        ...myCardsRoutes(navigation),
      ],
    }),
  ]
})
